import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { OfferType } from '@smg-real-estate/hg-rets-schema';
import { NavigationGuardNext, RouteLocation, RouteLocationNormalizedGeneric } from 'vue-router';

import emailTokenNavGuard from '@/helpers/emailTokenNavGuard';
import { GTMPageType } from '@/helpers/GTM/GTMParameters';
import DetailPage from '@/views/DetailPage/DetailPage.vue';

// TODO, simplify after we migrate to the new routing system for is24 as well
const detailPageRoute = {
  [HgSupportedLanguage.EN]: {
    [OfferType.Rent]: 'rent',
    [OfferType.Buy]: 'buy',
  },
  [HgSupportedLanguage.DE]: {
    [OfferType.Rent]: 'mieten',
    [OfferType.Buy]: 'kaufen',
  },
  [HgSupportedLanguage.FR]: {
    [OfferType.Rent]: 'louer',
    [OfferType.Buy]: 'acheter',
  },
  [HgSupportedLanguage.IT]: {
    [OfferType.Rent]: 'affittare',
    [OfferType.Buy]: 'acquistare',
  },
};

export const getDetailPageRoutes = () => {
  return Object.entries(detailPageRoute)
    .map(([locale, localizedOfferTypeMap]) =>
      Object.entries(localizedOfferTypeMap).map(([offerType, path]) => ({
        path: `/${path}/:listingId`,
        component: DetailPage,
        beforeEnter: async (
          targetRoute: RouteLocationNormalizedGeneric,
          sourceRoute: RouteLocationNormalizedGeneric,
          next: NavigationGuardNext,
        ) => {
          emailTokenNavGuard(targetRoute, sourceRoute, next);
        },
        name: `detailPage-${offerType}-${locale}`,
        alias: `/${path}/:listingId/*`,
        props: (currentRoute: RouteLocation) => ({
          listingIdFromRoute: currentRoute.params.listingId,
          scroll: currentRoute.params.scroll,
        }),
        meta: {
          locale,
          viewName: 'Detail Page',
          offerType,
          gtmPageType: GTMPageType.DETAIL_PAGE,
          getLanguageSwitchLink(route: any, language: HgSupportedLanguage) {
            return {
              name: `detailPage-${offerType}-${language}`,
              query: route.query,
              params: route.params,
            };
          },
        },
      })),
    )
    .reduce((routes, routeConfigForLocale) => [...routes, ...routeConfigForLocale]);
};
